import React, { useEffect, useState,useContext } from 'react'
import {Navigate } from "react-router-dom";
import API from '../../../API'
import Tests from './tests'
import Context from "../../../context";
import Loader from "../../../layouts/Loader";

export default function TestEditor() {
    const {mainState, isLoading, setIsLoading} = useContext(Context);
    const api = new API();
    const [tests, setTests] = useState();

    useEffect(
        () => {
            if (tests === undefined) {
                setIsLoading(true)
                api.getTests().then((data) => {
                    setTests(data)
                    setIsLoading(false)
                }).catch(err=> setIsLoading(false))
            }
        }, [tests])


    return (
        mainState.isLoggedIn && (mainState.type === "Editor" ||mainState.type === "Admin") ?
            <div className="test-creator-background">
                <div className="test-creator-main">
                    <div className="test-creator-container">
                        {isLoading && <Loader/>}
                        {tests && <Tests data={tests} SetData={setTests}/>}
                    </div>
                </div>
            </div> :
            <Navigate to="/*"/>
    )
}

